import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
const styles = {
  active: {
    // background: "#285979",
    background: "#2b5875",
    border: "2px solid white ",
    color: "#fff",
    width: "100%",
    // border: "none",
    // padding: "0.8rem",
    cursor: "pointer",
    borderRadius: "10px",
  },
  inactive: {
    background: "#336699",
    border: "2px solid white ",
    borderRadius: "10px",
    width: "100%",
  },
};
const CatalogueProducts = ({ category, productCollection, signatureLook, ...props }) => {
  // const [isLiked, setIsLiked] = React.useState(false);
  const number = "919100004949";
  const [products, setProducts] = React.useState([]);

  // Build the WhatsApp link. On desktop, open WhatsApp Web directly; on mobile,
  // use wa.me so the native app opens.
  const openWhatsApp = (product) => {
    const message = product?.productCode
      ? `I am interested in ${product.name} (${product.productCode}).`
      : `I am interested in ${product.name}.`;
    const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(
      navigator.userAgent
    );
    const url = isMobile
      ? `https://wa.me/${number}?text=${encodeURIComponent(message)}`
      : `https://web.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(
          message
        )}`;
    window.open(url, "_blank");
  };

  const [loading, setLoading] = React.useState(false);

  const getAllProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/product/getAll");
      const allProducts = response.data.product || [];

      if (!category && !productCollection && !signatureLook) {
        setProducts(allProducts);
      } else {
        const norm = (v) => (v || "").toString().trim().toLowerCase();
        const filteredProducts = allProducts.filter((product) => {
          const matchesCollection =
            productCollection &&
            norm(product.productCollection) === norm(productCollection);
          const matchesSignatureLook =
            signatureLook &&
            norm(product.signatureLook) === norm(signatureLook);
          const matchesCategory =
            category && norm(product.category) === norm(category);
          return matchesCollection || matchesSignatureLook || matchesCategory;
        });
        // Show only the matching products. If none match, show an empty grid
        // (do NOT fall back to all products — that mixes collections).
        setProducts(filteredProducts);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getAllProducts();
  }, []);

  const [existingButtons, setExistingButtons] = useState(["All"]);

  useEffect(() => {
    // Fetch existing buttons based on product categories
    const categories = products.map((product) => product.category);
    setExistingButtons(["All", ...new Set(categories)]);
  }, [products]);

  const buttonExists = (name) => {
    return existingButtons.includes(name);
  };
  const [activeButton, setActiveButton] = useState("All");
  const [filterProducts, setFilterProducts] = useState(products);
  const filterProduct = (name) => {
    const oldProduct = products;
    setActiveButton(name);

    if (name === "All") {
      setFilterProducts(oldProduct);
    } else {
      const filterData = oldProduct.filter(
        (product) => product.category === name
      );

      setFilterProducts(filterData);
    }
  };

  return (
    <div style={{ width: "100vw", overflowX: "hidden" }}>
      <div
        className="container"
        // style={{ margin: "auto", justifyContent: "center" }}
      >
        {!loading && products.length === 0 && (
          <div className="d-flex justify-content-center">
            <h2 style={{ color: "#285979", fontFamily: "Raleway" }}>
              No Products Found
            </h2>
          </div>
        )}
        {loading ? (
          <div className="d-flex justify-content-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div
            className="row justify-content-center"
            style={{
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {products.map((product) => (
              <div className="col-lg-3 col-md-4 col-6 mt-2 " key={product.id}>
                <div className="card" style={{}}>
                  {/* <div className="card-header">
                      <strong style={{ fontFamily: "Hahmlet" }}>
                        {isLiked ? (
                          <CircleHeartRed
                            width="32"
                            height="32"
                            className="card-icon"
                          />
                        ) : (
                          <CircleHeart
                            width="32"
                            height="32"
                            className="card-icon"
                          />
                        )}
                      </strong>
                    </div> */}
                  <div style={{
                      width: "100%",
                      aspectRatio: "3 / 4",
                      overflow: "hidden",
                    }}>
                    <img
                      src={product?.image[0]?.url}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      className="card-img-top"
                      alt={product?.name || "Product"}
                    />
                  </div>

                  <div className="card-footer">
                    <strong style={{ fontFamily: "Raleway", color: "#285979" }}>
                      {product?.name}
                    </strong>
                    <p className="card-text">{product?.productCode}</p>
                    <strong
                      style={{ fontFamily: "Raleway", color: "#285979" }}
                    ></strong>
                  </div>
                  <NavLink
                    onClick={() => openWhatsApp(product)}
                    className="btn text-white product-button"
                    width="100%"
                  >
                    Know More
                  </NavLink>
                </div>
              </div>
            ))}
            {/* {products &&
              filterProducts.length === 0 &&
              products.map((product) => (
                <div className="col-lg-3 col-md-4 col-6 mt-2 " key={product.id}>
                  <div className="card" style={{}}>
                   
                    <img
                      src={product.image[0].url}
                      width={315}
                      height={290}
                      className="card-img-top"
                      alt="..."
                    />
                    <div className="card-body"></div>
                    <div className="card-footer">
                      <strong style={{ fontFamily: "Hahmlet" }}>
                        {product.name}
                      </strong>
                      <p className="card-text">{product?.productCode}</p>
                      <strong style={{ fontFamily: "Hahmlet" }}></strong>
                    </div>
                    
                    <NavLink
                      onClick={() => {
                        window.open(
                          `https://wa.me/${number}?text=I'm%20interested%20in%20"${product.name}"%20"${product.productCode}"%0A%0Acontact%20me%20on%20${number}`
                        );
                      }}
                      className="btn text-white product-button"
                      width="100%"
                    >
                      Know More
                    </NavLink>
                  </div>
                </div>
              ))} */}
          </div>
        )}
      </div>
    </div>
  );
};

export default CatalogueProducts;
